import { Box, Typography } from "@mui/material";
import { useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left.svg";
import ButtonTabbar from "../../../components/ButtonTabbar";

import NewRequest from "./NewRequest";
import ActiveRequests from "./ActiveRequests";

export default function WithdrawWallet() {
  const [tabIndex, setTabIndex] = useState(0);

  const tabbuttons = [
    {
      title: "درخواست جدید",
    },
    {
      title: "درخواست‌های فعال",
    },
  ];
  return (
    <>
      <MobileHeader title={HeadTitle()} hasScroll={false} />
      <Box
        sx={{
          flex: 1,
          paddingX: "8px",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            padding: "14px 6px",
            backgroundColor: "bgColor.white",
            borderWidth: "0.5px",
            borderStyle: "solid",
            borderColor: "info.main",
            borderRadius: "10px",
            paddingBottom: "100px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <ButtonTabbar
            activeIndex={tabIndex}
            handleChangeTab={(index) => setTabIndex(index)}
            buttons={tabbuttons}
          />

          {tabIndex === 0 ? <NewRequest /> : <ActiveRequests />}
        </Box>
      </Box>
    </>
  );
}

function HeadTitle() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          color: "secondary.main",
          fontSize: "14px",
        }}
      >
        کیف پول
      </Typography>
      <img src={ArrowTickLeft} alt="" />
      <Typography
        variant="body2"
        sx={{
          color: "secondary.main",
        }}
      >
        برداشت پول{" "}
      </Typography>
    </Box>
  );
}
